const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目基本情况',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '中标结果信息',
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post('/transformToAfter/app/home/zbjgDetail', {
                guid: this.$route.query.id,
                bdGuid: this.$route.query.bdGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.data.bdName,
                    '标段/包编号': res.data.data.bdBH,
                    '项目类型': getProjectTypeName(res.data.data.zbxmlx),
                    '采购方式': getPurchaseTypeName(res.data.data.cgFangShi),
                    '行业分类': res.data.hangYe,
                }
                if (res.data.data.xiangmuXingzhi === 3) {
                    this.config[1].options.data['经营资产交易类型'] = res.data.data.jyzcTransType === 1 ? '资产处置' : '租赁'
                }
                res.data.data.jggsList.forEach((item) => {
                    this.config.push({
                        component: 'ZlmNormalDetail',
                        options: {
                            data: {
                                '中标候选人名称': item.tbrName,
                                '中标价(元)': item.zhongBiaoJia,
                            },
                        },
                    })
                })
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
